<template>
    <b-card :class="{ 'place-card_return': type === 'return' }" class="place-card">
        <template v-slot:header>
            <div class="d-flex justify-content-between">
                <div>
                    {{ place.shipment.num }}
                    <b-badge v-if="isAccepted" variant="success" class="ml-2">{{ place.acceptedReturn ? 'Принято на возврат' : 'Принято' }}</b-badge>
                </div>
                <div>{{ place.shipment.courierCode }}</div>
            </div>
        </template>
        <b-alert v-if="place.shipment.error" variant="danger" show>{{ place.shipment.error }}</b-alert>
        <b-card class="place-card__subcard">
            <small class="text-black-50">Штрихкод</small>
            <h4>{{ place.barcode }}</h4>
            <b-form>
                <b-row>
                    <b-col xl="3" class="mb-3">
                        <small class="text-black-50">Вес (г)</small>
                        <b-input v-model="placeDimension.weight" :disabled="isAccepted" number></b-input>
                        <small class="text-black-50">{{ actualDimension.weight }} г</small>
                    </b-col>
                    <b-col xl="3" class="mb-3">
                        <small class="text-black-50">Ширина (мм)</small>
                        <b-input v-model="placeDimension.width" :disabled="isAccepted" number></b-input>
                        <small class="text-black-50">{{ actualDimension.width }} мм</small>
                    </b-col>
                    <b-col xl="3" class="mb-3">
                        <small class="text-black-50">Высота (мм)</small>
                        <b-input v-model="placeDimension.height" :disabled="isAccepted" number></b-input>
                        <small class="text-black-50">{{ actualDimension.height }} мм</small>
                    </b-col>
                    <b-col xl="3" class="mb-3">
                        <small class="text-black-50">Глубина (мм)</small>
                        <b-input v-model="placeDimension.depth" :disabled="isAccepted" number></b-input>
                        <small class="text-black-50">{{ actualDimension.depth }} мм</small>
                    </b-col>
                    <b-col xl="12" class="d-flex justify-content-between">
                        <b-button v-if="controls.indexOf('acceptBtn') !== -1" @click="onAccept" type="button" variant="success">{{ acceptBtnText }}</b-button>
                        <div v-if="controls.indexOf('printStickerBtn') !== -1" class="d-flex">
                            <b-input-group v-if="controls.indexOf('stickerDateInput') !== -1" class="w-auto mr-2">
                                <b-form-input v-model="stickerDate" placeholder="YYYY-MM-DD"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="stickerDate" button-only right locale="ru-RU" @context="stickerDate = $event.selectedYMD"></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button @click="printPlaceSticker(place)" type="button" :disabled="stickerLoading">Печать стикера</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-card>
    </b-card>
</template>

<script>
    import axios from "axios";
    import NotificationMixin from "../mixins/NotificationMixin";

    export default {
        name: "PlaceAcceptCard",

        mixins: [
            NotificationMixin,
        ],

        props: {
            type: {
                type: String,
                required: false,
                validator: val => ['default', 'return'].indexOf(val) !== -1,
                default: 'default',
            },
            place: {
                type: Object,
                required: true,
            },
            controls: {
                type: Array,
                required: false,
                default: ['acceptBtn'], // printStickerBtn, stickerDateInput
            },
            stickerDate: {
                type: String,
                required: false,
                default: '',
            },
            acceptBtnText: {
                type: String,
                required: false,
                default: 'Принять',
            },
        },

        data() {
            return {
                placeDimension: {
                    weight: 0,
                    width: 0,
                    height: 0,
                    depth: 0,
                },
                stickerLoading: false,
            };
        },

        computed: {
            isAccepted() {
                switch (this.type) {
                    case 'return':
                        return !!this.place.acceptedReturn;
                    case 'default':
                    default:
                        return this.place.accepted && !this.place.shipment.error;
                }
            },
            actualDimension() {
                return {
                    weight: this.place.actualDimension ? this.place.actualDimension.weight : this.place.dimension.weight,
                    width: this.place.actualDimension ? this.place.actualDimension.width : this.place.dimension.width,
                    height: this.place.actualDimension ? this.place.actualDimension.height : this.place.dimension.height,
                    depth: this.place.actualDimension ? this.place.actualDimension.depth : this.place.dimension.depth,
                }
            },
        },

        watch: {
            place: {
                immediate: true,
                handler: function(val, oldVal) {
                    if (this.isAccepted) {
                        this.placeDimension.weight = this.actualDimension.weight;
                        this.placeDimension.width = this.actualDimension.width;
                        this.placeDimension.height = this.actualDimension.height;
                        this.placeDimension.depth = this.actualDimension.depth;
                    } else {
                        this.placeDimension.weight = 0;
                        this.placeDimension.width = 0;
                        this.placeDimension.height = 0;
                        this.placeDimension.depth = 0;
                    }
                },
            },
        },

        methods: {
            onAccept() {
                if (this.placeDimension.weight && this.placeDimension.width && this.placeDimension.height && this.placeDimension.depth) {
                    this.$emit('accept', this.place, this.placeDimension);
                } else {
                    this.showErrors('Некорректное значение размеров');
                }
            },
            printPlaceSticker(place) {
                this.stickerLoading = true;
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + '/api/getPrintForm',
                    method: 'POST',
                    data: {
                        format: 'PDF',
                        placeId: place.dlvPlaceId,
                        dlvId: place.shipment.dlvId,
                        type: 'FULL_INVOICE1',
                        fullyPacked: true,
                        date: this.controls.indexOf('stickerDateInput') !== -1 ? this.stickerDate + 'T00:00:00' : undefined,
                    },
                }).then(resp => {
                    if (resp.data.sticker || resp.data.invoice) {
                        const linkSource = `data:application/pdf;base64,` + (resp.data.sticker ? resp.data.sticker : resp.data.invoice);
                        const downloadLink = document.createElement('a');
                        const fileName = (resp.data.sticker ? 'sticker' : 'invoice') + '-' + place.barcode + '.pdf';

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();

                        downloadLink.remove();
                    }
                }).catch(err => {
                    this.showErrors(err.response.data.errors);
                }).finally(() => {
                    this.stickerLoading = false;
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .place-card {
        border-color: #5f8050;
        background-color: #f1fde6;

        &__subcard {
            border-color: #aaa85d;
            background-color: #ffffe7;
        }

        &.place-card_return {
            border-color: #505e80;
            background-color: #e6f3fd;

            .place-card__subcard {
                border-color: #5d98aa;
                background-color: #f2fbff;
            }
        }
    }
</style>